import React from 'react';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { SwapHoriz } from '@mui/icons-material';

function NumericalInfo({ title, data, headerActionCallback, footer, noSeparator = false }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%'
      }}
    >
      <Box
        sx={{
          width: '100%',
          mb: 3.5,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {headerActionCallback ? (
          <SwapHoriz color="#9B959F" onClick={headerActionCallback} sx={{ cursor: 'pointer' }} />
        ) : null}
        <Typography
          color="#00010E"
          fontSize={20}
          fontFamily={'Mulish'}
          fontWeight={600}
          letterSpacing="0.01938em"
          lineHeight="22px"
          textAlign="center"
          sx={{ ml: headerActionCallback ? '10px' : 0 }}
        >
          {title}
        </Typography>
      </Box>
      <Box
        sx={{
          borderRight: noSeparator ? 'none' : '1px solid rgba(0, 0, 0, 0.25)'
        }}
      >
        <Typography fontSize={48} fontWeight={600} letterSpacing="0.01938em" lineHeight="58px">
          {data}
        </Typography>
      </Box>
      <Box pt={3}>{footer}</Box>
    </Box>
  );
}

NumericalInfo.propTypes = {
  data: PropTypes.any.isRequired,
  headerActionCallback: PropTypes.func,
  title: PropTypes.string.isRequired,
  footer: PropTypes.any.isRequired,
  noSeparator: PropTypes.bool
};

export { NumericalInfo };
